import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authenticateUser } from "./../../REDUX/Models/users.Model";
import { addUser, signIn, setError } from "./../../REDUX/Slices/users.Slice";
import { useSelector, useDispatch } from "react-redux";
import login from "./../../assets/icons/login.svg";
import "./index.scss";

export default function Login() {
  const [icon, setIcon] = useState("fa-light fa-lock");
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });

  const err = useSelector((state) => state.error);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
    dispatch(setError(null));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(null));

    try {
      if (!inputs.email || !inputs.password) {
        dispatch(setError("من فضلك أدخل البريد الإلكتروني وكلمة المرور"));
        return;
      }

      await authenticateUser(inputs).then((res) => {
        const { response, token } = res.data.user;
        dispatch(addUser({ response, token }));
        dispatch(signIn());
      });

      navigate("/loading", { replace: true });
    } catch (err) {
      let errorMsg = "حدث خطأ، يرجى المحاولة لاحقًا.";
      const status = err?.response?.status;
      if (status === 401) {
        errorMsg = "البريد الإلكتروني أو كلمة المرور غير صحيحة.";
      } else if (status === 500) {
        errorMsg = "خطأ في الخادم. حاول مرة أخرى لاحقًا.";
      }

      dispatch(setError(errorMsg));
    }
  };

  useEffect(() => {
    document.title = `طورنى - تسجيل دخول`;
    dispatch(setError(null));
  }, []);

  return (
    <div className="login">
      <div className="container">
        <div className="row">
          <div className="login-img">
            <img src={login} alt="Login" />
          </div>
          <div className="login-form">
            <h2>تسجيل دخول</h2>

            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <input
                  type="email"
                  name="email"
                  placeholder="البريد الالكترونى"
                  value={inputs.email}
                  required
                  onChange={handleChange}
                />
                <i className="fa-light fa-envelope input-icon"></i>
              </div>

              <div className="input-field">
                <input
                  type={icon === "fa-light fa-lock" ? "password" : "text"}
                  name="password"
                  placeholder="كلمة السر"
                  value={inputs.password}
                  required
                  onChange={handleChange}
                />
                <i
                  className={`${icon} input-icon`}
                  onClick={() =>
                    setIcon((prev) =>
                      prev === "fa-light fa-lock"
                        ? "fa-light fa-lock-open"
                        : "fa-light fa-lock"
                    )
                  }
                ></i>
              </div>

              <button type="submit">دخول</button>
            </form>

            <div className="links">
              <Link to="/reset-password">نسيت كلمة السر؟</Link>
              <Link to="/register">تسجيل حساب جديد</Link>
              {err && <span>{err}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
